import styled from "styled-components";
import ReactSelect from "react-select";

export const StyledSelect = styled(ReactSelect)`
  height: 40px;
  width: 100%;
  color: ${(props) => props.theme.greyTextColor};
`;

